module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_8019.59f717fb.png";